export default "__VITE_ASSET__BnALOsqa__"